import { IMAncillaryContent, IMAncillaryContentItem, IMCourse } from '../types'
import { INoteNode } from '../../../components/ingestion/IngestedTree'
import { createNodeList } from '../../nodeCreationHelpers'
import { createNoteNode } from './createNodeWrappers'
import { IM360Parser } from './IM360Parser'

function createGlossaryEntries(glossaryEntries: IMAncillaryContentItem[]) {
  const glossaryDict = glossaryEntries.reduce<Record<string, string>>(
    (acc, item) => {
      if (!item.description) return acc
      return {
        ...acc,
        [item.title]: item.description,
      }
    },
    {},
  )
  return Object.keys(glossaryDict)
    .sort()
    .reduce<INoteNode[]>((acc, title) => {
      const description = glossaryDict[title]
      if (description) {
        acc.push(
          createNoteNode({
            title,
            value: description,
            studentFacing: true,
          }),
        )
      }
      return acc
    }, [])
}

function createGlossaryForItems(
  items: IMAncillaryContentItem[],
  title?: string,
) {
  const parser = IM360Parser.getInstance()
  const noteEntries = createGlossaryEntries(items)
  return parser.createActivity(
    {
      title: title ?? 'Glossary',
    },
    noteEntries,
  )
}

export function createItemGlossary(
  ancillaryContent?: IMAncillaryContent,
  title?: string,
) {
  if (!ancillaryContent?.glossary_entries?.length) return []
  return [
    createNodeList({ title: 'Glossary' }, [
      createGlossaryForItems(ancillaryContent?.glossary_entries, title),
    ]),
  ]
}

export function createCourseGlossary(imCourse: IMCourse) {
  const allEntries = imCourse.units.reduce<IMAncillaryContentItem[]>(
    (acc, unit) => {
      acc.push(...(unit.ancillary_content?.glossary_entries ?? []))
      unit.sections.forEach((section) =>
        section.lessons.forEach(({ ancillary_content }) => {
          return acc.push(...(ancillary_content?.glossary_entries ?? []))
        }),
      )
      return acc
    },
    [],
  )
  if (!allEntries.length) return []
  return [
    createNodeList({ title: 'Resources From Kiddom' }, [
      createGlossaryForItems(allEntries, `${imCourse.title} Glossary`),
    ]),
  ]
}
